import React from 'react';
import Svg from '../Svg';

const IconCurrencyEuro = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.06609 11C6.0225 11.3271 6 11.6609 6 12C6 12.3391 6.0225 12.6729 6.06609 13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H6.62407C7.7814 17.6489 10.4245 19.5 13.5 19.5C15.3515 19.5 17.0441 18.8304 18.3526 17.7188C18.7735 17.3613 19.4046 17.4126 19.7621 17.8336C20.1197 18.2545 20.0683 18.8855 19.6474 19.2431C17.991 20.6502 15.8435 21.5 13.5 21.5C9.30162 21.5 5.73933 18.7766 4.48341 15H3C2.44772 15 2 14.5523 2 14C2 13.4477 2.44772 13 3 13H4.052C4.01762 12.6714 4 12.3377 4 12C4 11.6623 4.01762 11.3286 4.052 11H3C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H4.48341C5.73933 5.22342 9.30162 2.5 13.5 2.5C15.8435 2.5 17.991 3.34982 19.6474 4.7569C20.0683 5.11445 20.1197 5.74553 19.7621 6.16645C19.4046 6.58737 18.7735 6.63873 18.3526 6.28117C17.0441 5.16965 15.3515 4.5 13.5 4.5C10.4245 4.5 7.7814 6.35114 6.62407 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H6.06609Z"
    />
  </Svg>
);

export default IconCurrencyEuro;
